import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultOrderSeatPickerAssets, orderSeatPickerAssetsValidator } from './assets';
import { defaultOrderSeatPickerConfig, orderSeatPickerConfigValidator } from './config';
import { defaultOrderSeatPickerDisplayText, orderSeatPickerDisplayTextValidator } from './display-text';
import { orderSeatPickerEventsValidator } from './events';
export const defaultOrderSeatPickerProps = {
    assets: defaultOrderSeatPickerAssets,
    displayText: defaultOrderSeatPickerDisplayText,
    events: {},
    config: defaultOrderSeatPickerConfig
};
export const orderSeatPickerPropsValidator = Validator.object({
    friendSeatIds: Validator.optional(Validator.array({ items: nonEmptyStringValidator })),
    events: orderSeatPickerEventsValidator,
    config: orderSeatPickerConfigValidator,
    displayText: orderSeatPickerDisplayTextValidator,
    assets: orderSeatPickerAssetsValidator
});
